<template>

    <trax-ui-ajax-table-with-crud-actions
        :id="id" :titles="titles" :props="props" :bus="bus" :actions="actions"
        :endpoint="endpoint" :endpoint-params="endpointParams"
        :edit-url="edit_url" :delete="canManage">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: ['bus', 'withUsername'],

        data() {
            var titles = [
                lang.polaris.account.fullname,
                lang.polaris.account.role + ' / ' + lang.polaris.account.organization,
                lang.polaris.common.medical_certificate,
                ''
            ];
            var props = [
                {source: this.fullname, order: 'lastname'},
                {source: this.roleOrganization },
                {source: this.medicalCertificate }
            ];
            if (this.withUsername) {
                titles.unshift(lang.polaris.account.username + ' / ' + lang.polaris.account.email);
                props.unshift({source: this.usernameEmail, order: 'username'});
            } else {
                titles.unshift(lang.polaris.account.email);
                props.unshift({source: this.email, order: 'email'});
            }
            return {
                user: user,
                endpoint: app_url+"polaris/api/front/users",
                endpointParams: {
                    relations: ['role', 'entity', 'subentity']
                },
                edit_url: app_url+"polaris/ui/account/user/edit",
                titles: titles,
                props: props,
                actions: [
                    {
                        name: 'login-as',
                        icon: 'exit_to_app',
                        class: 'btn-default',
                        title: lang.polaris.account.login_as,
                        event: 'login-as',
                        condition: this.canLoginAs
                    }
                ],
                id: 'trax-account-user'
            }
        },

        computed: {

            // The supervisors don't delete accounts.
            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            }
        },

        methods: {

            // Columns rendering

            email(data, type, row, meta) {
                return this.active(row, row.email);
            },

            fullname(data, type, row, meta) {
                return this.active(row, row.name);
            },

            usernameEmail(data, type, row, meta) {
                let icon = '';
                if (row.source != 'internal') {
                    icon = '<i class="fa fa-plug ml-1"></i>';
                }
                var username = '<span class="font-weight-bold">' + row.username + icon + '</span><br>';
                var email = '<small class="font-weight-light">' + row.email + '</small>';
                return this.active(row, username + email);
            },

            medicalCertificate(data, type, row, meta) {
                var date = row.meta ? row.meta.medical_exam_expiry_date : null;
                if (!date) {
                    return '';
                }

                // Dates close to expiry or expired are highlighted.
                var diff = moment().diff(date, 'days');
                var cellClass = '';
                if (diff > -14) {
                    cellClass = 'text-danger';
                } else if (diff > -60) {
                    cellClass = 'text-warning';
                }

                var icon = '<i class="fa fa-plus mr-1"></i>';
                return '<small class="' + cellClass + ' text-nowrap">' + icon + moment(date).format('DD MMM YYYY') + '</small>';
            },

            roleOrganization(data, type, row, meta) {
                var role = ''
                if (row.admin) {
                    role = 'Super-Admin <br>';
                } else if (row.role) {
                    role = row.role.name + '<br>';
                }

                var entity = '<small class="font-weight-light">';
                if (row.entity) entity += row.entity.name;
                if (row.subentity) entity += ' / ' + row.subentity.name;
                entity += '</small>'

                return this.active(row, role + entity);
            },

            // Reserved to super-admins, and never on a super-admin, an inactive account or
            // ourselves. The back-end applies the same rules.
            canLoginAs(row) {
                return user.admin && !row.admin && row.active && row.id != user.id;
            },

            active(row, content) {
                if (row.active) return content;
                return '<span class="trax-text-muted">' + content + '</span>';
            }
        }

    }
</script>
